import cuid from 'cuid';

export const getUniqueId = () => {
  const storageKey = 'app-unique-id';

  const storedId = localStorage.getItem(storageKey);
  if (storedId) {
    return storedId;
  }

  const generatedId = cuid();
  localStorage.setItem(storageKey, generatedId);
  return generatedId;
};
